import React from 'react';
import { useTranslation } from 'react-i18next';
import { Page, theme, PageHeaderLogo, PageContainerVCenter, Typo } from '../../ui';

const NotFound = () => {

  const { t } = useTranslation();


  return (
    <Page backgroundColor={theme.colors.PRIMARY} fullheight={true}>
      <PageHeaderLogo />
      <PageContainerVCenter>
        <Typo.ContentSmallHeader $themeColor={theme.colors.PRIMARY} >{t('genericPages.notFoundPage.genericMessage')}</Typo.ContentSmallHeader>
      </PageContainerVCenter>
    </Page>
  );
};

export default NotFound;
